module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/1-0cd6f9253d2d6c70a192335aacd5e6cb.jpg";